import ExhibitionSection from '../../components/ExhibitionSection/ExhibitionSection';

export default function DigitalGarden({ lang }) {
    return (
            <ExhibitionSection
                titleEn="Exhibition Area 2: Digital Garden"
                titleZh="展区二：数字花园"
                campus="guangzhou"
                area={2}
                lang={lang}
            />
    );
}
